import * as React from "react";
import usePluggableEntityTableElements from "hooks/usePluggableEntityTableElements";
import RowActionMenu from "./row-action-menu";
export const EVENT_PROCEDURES_STEPLIST_ID = "eventProceduresStepList";
export const ATTRIBUTES = [
  {
    id: "title",
    title: "Title",
    type: "STRING",
    sortable: true
  },
  {
    id: "description",
    title: "Description",
    type: "STRING"
  },
  {
    id: "type",
    title: "Action",
    type: "STRING"
  }
];
export const useListElements = () => {
  var _a;
  const { pluggableAttributes } = usePluggableEntityTableElements(
    null,
    "event_procedure_step"
  );
  const attributes = ((_a = pluggableAttributes == null ? void 0 : pluggableAttributes.attributeNames) == null ? void 0 : _a[0]) ? ["title", "description", "type", pluggableAttributes.attributeNames[0]] : ["title", "description", "type"];
  return {
    defaultLayout: {
      entityTableId: EVENT_PROCEDURES_STEPLIST_ID,
      defaultPageSize: 20,
      defaultSort: { attributeId: "title", direction: "asc" },
      defaultDisplayedAttributes: attributes,
      defaultColumnOrder: attributes
    }
  };
};
export const useDeserializeEventProceduresSteps = () => {
  const { pluggableAttributes } = usePluggableEntityTableElements(
    null,
    "event_procedure_step"
  );
  return ({ page, per_page, total, count, event_procedure_steps }) => ({
    attributes: [...ATTRIBUTES, ...(pluggableAttributes == null ? void 0 : pluggableAttributes.attributes) || []],
    list: (pluggableAttributes == null ? void 0 : pluggableAttributes.attributeNames) ? event_procedure_steps.map((step) => {
      var _a, _b;
      return {
        ...step,
        type: (_b = (_a = step == null ? void 0 : step.action) == null ? void 0 : _a.config) == null ? void 0 : _b.type,
        collections: 0
      };
    }) : event_procedure_steps.map((step) => {
      var _a, _b;
      return {
        ...step,
        type: (_b = (_a = step == null ? void 0 : step.action) == null ? void 0 : _a.config) == null ? void 0 : _b.type
      };
    }),
    pagination: { total, page, per_page, count }
  });
};
export const entityActionRender = (step) => /* @__PURE__ */ React.createElement(RowActionMenu, { eventProcedureStep: step });
